var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#DDDDDD;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.317,
    y1: 27.1583,
    x2: 53.4691,
    y2: 35.3746,
    gradientTransform: "matrix(1 0 0 -1 0 64.2125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC6759"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,0h16c13.3,0,24,10.7,24,24v16c0,13.3-10.7,24-24,24H24C10.7,64,0,53.3,0,40V24C0,10.7,10.7,0,24,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,35l-1.1,1.1l4.7,4.7l1.1-1.1L44.3,35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,44.8l-1.1,1.1l4.7,4.7l1.1-1.1L34.6,44.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.8,52c-0.2,0-0.4-0.1-0.5-0.2c-0.2-0.2-0.2-0.5-0.2-0.7l1.3-6c0-0.2,0.1-0.3,0.2-0.4l12.4-12.5 c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.5,0.2l4.7,4.7c0.2,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5L39.3,50.4 c-0.1,0.1-0.2,0.2-0.4,0.2l-6,1.4C32.8,52,32.8,52,32.8,52z M34.8,45.6l-1,4.6l4.6-1l11.7-11.8l-3.6-3.6L34.8,45.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,48.6c-0.2-0.2-0.2-0.5,0-0.7l33.3-33.3c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L15.4,48.6 C15.2,48.8,14.8,48.8,14.6,48.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,16.3c3.4,0,6.5,2,8,5c-1.5,3.1-4.6,5-8,5s-6.5-2-8-5C15.5,18.3,18.6,16.3,22,16.3z M22,14.5 c-4.5,0-8.4,2.9-10,6.9c1.6,4,5.5,6.9,10,6.9s8.4-2.9,10-6.9C30.4,17.4,26.5,14.5,22,14.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,19.1c1.3,0,2.3,1,2.3,2.3s-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3S20.7,19.1,22,19.1z M22,17.2 c-2.3,0-4.1,1.9-4.1,4.1s1.8,4.1,4.1,4.1c2.3,0,4.1-1.9,4.1-4.1S24.3,17.2,22,17.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEdit);
export default __webpack_public_path__ + "static/media/view-edit.5e73b40cabcb79885c11e8048fc3e33c.svg";
export { ForwardRef as ReactComponent };